import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { USER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { captureException } from '../utils/sentryUtils';
const APP_HUB_USERS_FIELD = 'usersData';
const USER_PROPERTIES = ['hs_email', 'hs_given_name', 'hs_family_name', 'hs_internal_user_id', 'hubspot_owner_id'];
const FETCH_APP_HUB_USERS = registerQuery({
  fieldName: APP_HUB_USERS_FIELD,
  args: ['filterProperty', 'filterValues'],
  fetcher: ({
    filterProperty,
    filterValues
  }) => http.post('crm-search/search', {
    data: {
      count: filterValues.length,
      objectTypeId: USER_TYPE_ID,
      requestOptions: {
        properties: USER_PROPERTIES
      },
      filterGroups: [{
        filters: [{
          property: filterProperty,
          operator: 'IN',
          values: filterValues
        }]
      }]
    }
  })
});
export const useAppHubUsers = ({
  userIds,
  ownerIds
}) => {
  const isOwnerIdsFilter = (ownerIds || []).length > 0;
  const isUserIdsFilter = (userIds || []).length > 0;
  const filterProperty = isOwnerIdsFilter ? 'hubspot_owner_id' : 'hs_internal_user_id';
  const filterValues = isOwnerIdsFilter ? ownerIds : userIds;
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_APP_HUB_USERS, {
    variables: {
      filterProperty,
      filterValues
    },
    skip: !isUserIdsFilter && !isOwnerIdsFilter,
    onError: err => {
      captureException(err, {
        extra: {
          fingerprint: 'useAppHubUsers-crmSearch',
          filterProperty,
          filterValues
        }
      });
    }
  });
  const usersRecord = useMemo(() => {
    var _data$APP_HUB_USERS_F, _data$APP_HUB_USERS_F2;
    const record = {};
    const results = (_data$APP_HUB_USERS_F = data === null || data === void 0 || (_data$APP_HUB_USERS_F2 = data[APP_HUB_USERS_FIELD]) === null || _data$APP_HUB_USERS_F2 === void 0 ? void 0 : _data$APP_HUB_USERS_F2.results) !== null && _data$APP_HUB_USERS_F !== void 0 ? _data$APP_HUB_USERS_F : [];
    const keyProperty = isOwnerIdsFilter ? 'hubspot_owner_id' : 'hs_internal_user_id';
    for (const result of results) {
      var _result$properties$ke;
      const key = Number((_result$properties$ke = result.properties[keyProperty]) === null || _result$properties$ke === void 0 ? void 0 : _result$properties$ke.value);
      if (!isNaN(key)) {
        var _result$properties$hs, _result$properties$hs2, _result$properties$hs3, _result$properties$hs4, _result$properties$hs5, _result$properties$hs6, _result$properties$hu, _result$properties$hu2;
        record[key] = {
          email: (_result$properties$hs = (_result$properties$hs2 = result.properties.hs_email) === null || _result$properties$hs2 === void 0 ? void 0 : _result$properties$hs2.value) !== null && _result$properties$hs !== void 0 ? _result$properties$hs : '',
          firstName: (_result$properties$hs3 = (_result$properties$hs4 = result.properties.hs_given_name) === null || _result$properties$hs4 === void 0 ? void 0 : _result$properties$hs4.value) !== null && _result$properties$hs3 !== void 0 ? _result$properties$hs3 : '',
          lastName: (_result$properties$hs5 = (_result$properties$hs6 = result.properties.hs_family_name) === null || _result$properties$hs6 === void 0 ? void 0 : _result$properties$hs6.value) !== null && _result$properties$hs5 !== void 0 ? _result$properties$hs5 : '',
          ownerId: (_result$properties$hu = (_result$properties$hu2 = result.properties.hubspot_owner_id) === null || _result$properties$hu2 === void 0 ? void 0 : _result$properties$hu2.value) !== null && _result$properties$hu !== void 0 ? _result$properties$hu : ''
        };
      }
    }
    return record;
  }, [data, isOwnerIdsFilter]);
  return {
    usersRecord,
    loading,
    error
  };
};